export default {
    contractEditor: {
        backToDashboard: 'Natrag na nadzornu ploču',
        editContract: 'Uredi ugovor',
        deliveryLine: 'Isporuka: {start} → {end} · Ukupno: {total} · €{price}/MW',
        ref: 'Ref: {value}',
        traded: 'Trgovano: {value}',
        unit: 'Jedinica: {value}',
        attachments: '{count} privitak | {count} privitaka',
        saveRejected: 'Spremanje odbijeno',
        tabsAria: 'Kartice uređivača ugovora',
        tabBins: 'Košare',
        tabAudit: 'Revizija',
        runningTotals: 'Ukupno (zbroj košara): {total} kroz {days} dana · {dirty} nespremljeno',
        discard: 'Odbaci',
        confirmSave: 'Potvrdi i spremi',
        discardTitle: 'Odbaciti nespremljene izmjene?',
        discardBody: '{count} dan(a) ima nespremljene izmjene. Odbacivanjem ćete ih izgubiti.',
    },
}
